"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const class_serializer_1 = require("../serializers/class.serializer");
const sdk_constants_1 = require("../constants/sdk.constants");
const user_serializer_1 = require("../serializers/user.serializer");
const enums_1 = require("../enums");
class ClassClient {
    static newInstance(options, retryOptions) {
        return new ClassClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new class_serializer_1.ClassSerializer(new user_serializer_1.UserSerializer()));
    }
    constructor(client, serializer) {
        this.client = client;
        this.serializer = serializer;
    }
    findOne(classId, headers, schoolYearIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.findByIds([classId], headers, schoolYearIds).then((classes) => classes.length ? classes[0] : undefined);
        });
    }
    findByIds(classIds_1, headers_1, schoolYearIds_1) {
        return __awaiter(this, arguments, void 0, function* (classIds, headers, schoolYearIds, pagination = enums_1.PaginationFlag.ON) {
            const params = {
                classIds: classIds.join(','),
                schoolYearIds: schoolYearIds === null || schoolYearIds === void 0 ? void 0 : schoolYearIds.join(','),
                pagination,
            };
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/v2/class`, {
                headers,
                params,
            });
            return this.serialize(response.body.data.map((item) => item.class));
        });
    }
    findByOwner(headers_1, schoolYearIds_1) {
        return __awaiter(this, arguments, void 0, function* (headers, schoolYearIds, pagination = enums_1.PaginationFlag.ON) {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/v2/class`, {
                headers,
                params: {
                    limit: 100,
                    schoolYearIds: schoolYearIds === null || schoolYearIds === void 0 ? void 0 : schoolYearIds.join(','),
                    pagination,
                },
            });
            return this.serialize(response.body.data.map((item) => item.class));
        });
    }
    findByOwnerV3(filter, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/v3/class`, {
                headers,
                params: Object.assign(Object.assign({}, filter), { schoolIds: (_a = filter === null || filter === void 0 ? void 0 : filter.schoolIds) === null || _a === void 0 ? void 0 : _a.join(','), classIds: (_b = filter === null || filter === void 0 ? void 0 : filter.classIds) === null || _b === void 0 ? void 0 : _b.join(','), schoolYearIds: (_c = filter === null || filter === void 0 ? void 0 : filter.schoolYearIds) === null || _c === void 0 ? void 0 : _c.join(','), limit: 1000 }),
            });
            return this.serializeV3(response.body.data.map((item) => item.class));
        });
    }
    findByOwnerAndSchoolIds(headers_1, schoolIds_1, skip_1, limit_1, schoolYearIds_1) {
        return __awaiter(this, arguments, void 0, function* (headers, schoolIds, skip, limit, schoolYearIds, pagination = enums_1.PaginationFlag.ON) {
            let requestUrl = `${sdk_constants_1.ROSTERING_API_PREFIX}/v2/class`;
            const schoolIdsQueryParameter = Array.isArray(schoolIds) && schoolIds.length > 0
                ? schoolIds.join(',')
                : undefined;
            const response = yield this.client.get(requestUrl, {
                headers,
                params: {
                    schoolIds: schoolIdsQueryParameter,
                    schoolYearIds: schoolYearIds === null || schoolYearIds === void 0 ? void 0 : schoolYearIds.join(','),
                    skip: skip ? skip : 0,
                    limit: limit ? limit : 100,
                    pagination,
                },
            });
            return this.serialize(response.body.data.map((item) => item.class));
        });
    }
    findByOwnerAndClassIds(headers_1, classIds_1, schoolYearIds_1) {
        return __awaiter(this, arguments, void 0, function* (headers, classIds, schoolYearIds, pagination = enums_1.PaginationFlag.ON) {
            let requestUrl = `${sdk_constants_1.ROSTERING_API_PREFIX}/v2/class`;
            let classIdsQueryParam = Array.isArray(classIds) && classIds.length > 0
                ? classIds.join(',')
                : undefined;
            const params = {
                classIds: classIdsQueryParam,
                schoolYearIds: schoolYearIds === null || schoolYearIds === void 0 ? void 0 : schoolYearIds.join(','),
                limit: 100,
                pagination,
            };
            const response = yield this.client.get(requestUrl, {
                headers,
                params,
            });
            return this.serialize(response.body.data.map((item) => item.class));
        });
    }
    findByStudent(studentId, teacherId, classIds, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.client.get(`${sdk_constants_1.ROSTERING_API_PREFIX}/student/validate`, {
                headers,
                params: {
                    studentId,
                    teacherId,
                    classId: classIds === null || classIds === void 0 ? void 0 : classIds.join(','),
                },
            });
            return this.serialize(response.body.data);
        });
    }
    serialize(classes) {
        return classes.map((aClass) => this.serializer.serializeOne(aClass));
    }
    serializeV3(classes) {
        return classes.map((aClass) => this.serializer.serializeOneV3(aClass));
    }
}
exports.ClassClient = ClassClient;
//# sourceMappingURL=class.client.js.map